import * as React from 'react';
import b_ from 'b_';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import { getTabs } from './tabs';
import Content from '../Content/index';

import './index.scss';

interface Props {}

type Enhanced = Props & InjectedTranslateProps;

const b = b_.with('main-page-results-tabs');

const Tabs: React.FC<Enhanced> = ({ t }) => {
  return (
    <div className={b()}>
      {getTabs(t).map((tab, index) => (
        <div key={tab.id} className={b('tab')}>
          <input
            className={b('tab-input')}
            type={tab.type}
            id={tab.id}
            name={tab.name}
            defaultChecked={index === 0}
          />
          <label className={b('tab-title')} htmlFor={tab.id}>
            {tab.title}
          </label>
          <div className={b('tab-content')}>
            <Content tabIndex={index} />
          </div>
        </div>
      ))}
    </div>
  );
};

export default translate(Tabs);
